<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">{{ tituloPagina }}</h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Preencha os dados abaixo para {{ isEditMode ? 'editar' : 'cadastrar' }} o lançamento.
                </p>
            </div>
        </div>

        @if (idVenda) {
        <app-alert-card type="info" icon="shopping_cart" class="mb-3 d-block">
            Lançamento gerado pelo <strong>pedido de venda</strong>: só o pedido altera ou exclui (menu Ações do pedido).
        </app-alert-card>
        }

        @if (idNFeSaida) {
        <app-alert-card type="info" icon="description" class="mb-3 d-block">
            Lançamento gerado pela <strong>NF-e de saída</strong>: para alterar ou excluir, use "Excluir financeiro" na nota.
        </app-alert-card>
        }

        @if (isLoading) {
        <div class="section-container">
            <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
            <div class="row g-3 mt-1">
                <div class="col-12 col-xl-3">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-3">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-3">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-3">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
            </div>
            <div class="row g-3">
                <div class="col-12 col-xl-5">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-5">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
                <div class="col-12 col-xl-2">
                    <app-loading-box height="40" width="100%" marginTop="24"></app-loading-box>
                </div>
                <div class="col-12 col-xl-5">
                    <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
                </div>
            </div>
        </div>

        <div class="section-container">
            <app-loading-box height="30" width="240" marginTop="0"></app-loading-box>
            <app-loading-box height="56" width="40%" marginTop="16"></app-loading-box>
            <app-loading-box height="24" width="140" marginTop="20"></app-loading-box>
            <app-loading-box height="160" width="100%" marginTop="16"></app-loading-box>
        </div>

        <div class="section-container">
            <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
            <app-loading-box height="320" width="100%" marginTop="16"></app-loading-box>
        </div>

        <div class="section-container">
            <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
            <app-loading-box height="180" width="100%" marginTop="16"></app-loading-box>
        </div>
        } @else {
        <form [formGroup]="form" class="lancamento-form">
            @if (isContaCartao) {
            <app-alert-card type="info" icon="credit_card" class="mb-3 d-block">
                Conta tipo <strong>Cartão de Crédito</strong> — fecha dia <strong>{{ diaFechamentoCartao }}</strong>,
                vence dia <strong>{{ diaVencimentoCartao }}</strong>. Movimentações de saída não são permitidas
                diretamente.
            </app-alert-card>
            }
            <div class="row g-3 mb-3">
                <div class="col-12 col-xl-3">
                    <app-select-pesquisavel [control]="idContaOrigemControl" [offlineList]="contaOptions"
                        [preloadedOptions]="contaOptions" [idField]="'id'" [nameField]="'descricao'"
                        [label]="'Conta de Origem'" [isOptional]="true">
                    </app-select-pesquisavel>
                </div>

                <div class="col-12 col-xl-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Tipo</mat-label>
                        <mat-select [formControl]="tipoControl">
                            <mat-option [value]="1">Receita</mat-option>
                            <mat-option [value]="2">Despesa</mat-option>
                        </mat-select>
                        @if (tipoControl.hasError('required')) {
                        <mat-error>Este campo é obrigatório.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="col-12 col-xl-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Data</mat-label>
                        <input matInput [matDatepicker]="pickerData" [matDatepickerFilter]="cartaoDateFilter"
                            [readonly]="isContaCartao" formControlName="data" (input)="onDateInput($event)" />
                        <mat-datepicker-toggle matIconSuffix [for]="pickerData"></mat-datepicker-toggle>
                        <mat-datepicker #pickerData [startView]="isContaCartao ? 'year' : 'month'"
                            (monthSelected)="onMonthSelected($event, pickerData, form.get('data'))">
                        </mat-datepicker>
                        @if (form.get('data')?.hasError('required')) {
                        <mat-error>Este campo é obrigatório.</mat-error>
                        }
                    </mat-form-field>
                </div>

                <div class="col-12 col-xl-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Valor (R$)</mat-label>
                        <input matInput formControlName="valor" [currencyMask]="currencyMask">
                        @if (form.get('valor')?.hasError('required') || form.get('valor')?.hasError('min')) {
                        <mat-error>Informe um valor maior que zero.</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>

            <div class="row g-3 align-items-start mb-3">
                <div class="col-12 col-xl-5">
                    <app-select-pesquisavel [control]="categoriaControl" [offlineList]="categoriaOptions"
                        [preloadedOptions]="categoriaOptions" [idField]="'id'" [nameField]="'descricao'"
                        [label]="'Categoria'" [isOptional]="true">
                    </app-select-pesquisavel>
                </div>

                <div class="col-12 col-xl-4">
                    <app-select-pesquisavel [control]="centroCustoControl" [offlineList]="centroCustoOptions"
                        [preloadedOptions]="centroCustoOptions" [idField]="'id'" [nameField]="'descricao'"
                        [label]="'Centro de Custo'" [isOptional]="true">
                    </app-select-pesquisavel>
                </div>

                <div class="col-12 col-xl-3">
                    <mat-slide-toggle class="rateio-toggle" formControlName="isRateioCentroCusto" color="warn">
                        Rateio centro custo
                    </mat-slide-toggle>
                </div>
            </div>

            @if (rateioToggleControl.value) {
            <section class="section-container rateio-section">
                <div class="section-title">
                    <mat-icon>pie_chart</mat-icon>
                    <span>Rateio por Centro de Custo</span>
                </div>

                <div class="row g-3 align-items-start mb-5">
                    <div class="col-12 col-xl-4">
                        <button type="button" mat-stroked-button class="btn-secondary" (click)="abrirSeletorRateio()">
                            <mat-icon>percent</mat-icon> Selecionar configuração de rateio
                        </button>
                    </div>

                    <div class="col-12 col-xl-8">
                        <div class="rateio-toolbar">
                            <button type="button" mat-button class="add-rateio-btn" (click)="adicionarLinhaRateio()">
                                <mat-icon>add</mat-icon>
                                Adicionar
                            </button>
                        </div>
                    </div>
                </div>

                <div formArrayName="rateios" class="rateio-list">
                    @for (item of rateiosFormArray.controls; track item; let i = $index) {
                    <div class="rateio-row" [formGroupName]="i">
                        <app-select-pesquisavel [control]="getControl(item, 'idCentroCusto')"
                            [offlineList]="obterCentrosCustoDisponiveis(i)"
                            [preloadedOptions]="obterCentrosCustoDisponiveis(i)" [idField]="'id'"
                            [nameField]="'descricao'" [label]="'Centro de Custo'" [isOptional]="true">
                        </app-select-pesquisavel>

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Valor (R$)</mat-label>
                            <input matInput formControlName="valor" [currencyMask]="currencyMask">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Percentual (%)</mat-label>
                            <input matInput formControlName="percentual" [currencyMask]="decimalMask">
                        </mat-form-field>

                        <button type="button" class="remove-rateio-btn" (click)="removerLinhaRateio(i)"
                            [disabled]="rateiosFormArray.length === 1" matTooltip="Remover linha">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                    }
                </div>

                <app-percentual-progress-bar [somaPercentual]="totalPercentualRateio"></app-percentual-progress-bar>
            </section>
            }

            <div class="row g-3 mb-4">
                <div class="col-12">
                    <app-autocomplete-pesquisavel label="Cliente / Fornecedor"
                        placeholder="Pesquise por nome, CPF ou CNPJ" [formControl]="idPessoaControl"
                        [apiUrl]="urlPessoaLookup" idField="id" nameField="descricao" displayField="descricao"
                        [selectedItem]="pessoaSelecionada">
                    </app-autocomplete-pesquisavel>
                </div>
            </div>

            <div class="editor-section mb-4">
                <label class="field-label">Histórico / Descrição</label>
                <div class="editor-container">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="historicoHtml"
                        placeholder="Escreva aqui as observações adicionais..."></ngx-editor>
                </div>
                @if (form.get('historicoHtml')?.hasError('required') && form.get('historicoHtml')?.touched) {
                <div class="field-error">Este campo é obrigatório.</div>
                }
            </div>

            <div class="tags-section mb-4">
                <label class="field-label">Tags (Tags)</label>
                <app-select-pesquisavel [control]="tagsControl" label="Tags (Tags)" [offlineList]="tagOptions"
                    idField="idTagMovimentacao" nameField="descricao" [multiple]="true" [showBadges]="true"
                    subscriptSizing="dynamic" corField="cor">
                </app-select-pesquisavel>
            </div>

            <div class="anexos-section">
                <strong class="anexos-label">Anexos</strong>

                <div class="upload-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)">
                    <input #fileInput type="file" multiple accept=".pdf,.png,.jpg,.jpeg,.xml"
                        (change)="onFileSelected($event)" style="display: none;">

                    <div class="upload-dropzone" (click)="fileInput.click()">
                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                        <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
                        <p class="upload-hint">PDF, PNG, JPG ou XML (Máx 5MB por arquivo)</p>
                    </div>
                </div>

                @if (anexos.length > 0) {
                <div class="file-list mt-3">
                    @for (arquivo of anexos; track arquivo.nomeArquivo; let i = $index) {
                    <div class="file-item">
                        <div class="file-info">
                            <mat-icon class="file-icon">description</mat-icon>
                            <div class="file-details">
                                <span class="file-name">{{ arquivo.nomeArquivo }}</span>
                                <span class="file-size">{{ formatBytes(arquivo.tamanhoBytes) }}</span>
                            </div>
                        </div>
                        <div class="file-actions">
                            <button type="button" mat-icon-button (click)="baixarAnexo(arquivo)"
                                matTooltip="Baixar arquivo" class="action-icon">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button type="button" mat-icon-button (click)="removerAnexo(i)" matTooltip="Remover arquivo"
                                class="close-icon">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
        </form>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading || !!idVenda || !!idNFeSaida" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>